import styled from 'styled-components'

import Button from '../../../../../../shared/components/Button'

export const ContainerForm = styled.div`
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;

  input {
    width: 40vw;
    max-width: 420px;
    min-width: 513px;
  }

  button {
    margin-top: 20px;
  }
`

export const ContainerButton = styled.div`
  display: flex;

  flex-direction: column;

  position: absolute;
  bottom: 20px;

  align-items: center;

  @media (max-width: 1377px) {
    position: relative;
    bottom: -95px;
  }

  @media (max-height: 630px) {
    bottom: -15px;
  }

  @media (max-height: 585px) {
    bottom: -40px;
  }
`
export const ResendButton = styled(Button)`
  margin-bottom: 10px;
  width: 185px;
`
export const Container = styled.div`
  width: 100vw;
  display: flex;

  flex: 1;

  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  input {
    width: 40vw;
    max-width: 513px;
  }
`
